export const CURRENCIES = {
  INR: {
    code: "INR", symbol: "₹", locale: "en-IN", label: "India", flag: "🇮🇳",
    defaultCorpus: 25000000, defaultExpense: 100000, defaultExtra: 300000, defaultContribution: 50000,
  },
  USD: {
    code: "USD", symbol: "$", locale: "en-US", label: "USA", flag: "🇺🇸",
    defaultCorpus: 1500000, defaultExpense: 6000, defaultExtra: 15000, defaultContribution: 3000,
  },
  AED: {
    code: "AED", symbol: "AED", locale: "en-AE", label: "UAE", flag: "🇦🇪",
    defaultCorpus: 5000000, defaultExpense: 20000, defaultExtra: 50000, defaultContribution: 10000,
  },
};

export const CITY_TIERS = [
  { id: "tier1", label: "Tier 1", sub: "Metro city", note: "+20% cost", mult: 1.2 },
  { id: "tier2", label: "Tier 2", sub: "Mid-size city", note: "baseline", mult: 1.0 },
  { id: "tier3", label: "Tier 3", sub: "Small town", note: "−15% cost", mult: 0.85 },
];

export const BUCKET_COLORS = ["#2D6A4F", "#D99B26", "#D96B43", "#2A6F7F"];

export const THREE_BUCKETS = [
  { name: "Liquidity", allocation: 15, return: 6, color: BUCKET_COLORS[0] },
  { name: "Income", allocation: 35, return: 8, color: BUCKET_COLORS[1] },
  { name: "Growth", allocation: 50, return: 11, color: BUCKET_COLORS[2] },
];

export const FOUR_BUCKETS = [
  { name: "Liquidity", allocation: 12, return: 6, color: BUCKET_COLORS[0] },
  { name: "Income", allocation: 28, return: 8, color: BUCKET_COLORS[1] },
  { name: "Growth", allocation: 40, return: 11, color: BUCKET_COLORS[2] },
  { name: "Legacy", allocation: 20, return: 13, color: BUCKET_COLORS[3] },
];

export const DEFAULT_BUCKETS = THREE_BUCKETS;

// Non-corpus retirement income streams the planner can consolidate.
export const INCOME_TYPES = [
  { type: "Rental", label: "Rental Income", icon: "Home", growth: 5, color: "#2D6A4F" },
  { type: "FD", label: "Fixed Deposit Income", icon: "Landmark", growth: 0, color: "#D99B26" },
  { type: "PPF", label: "PPF Income", icon: "PiggyBank", growth: 0, color: "#2A6F7F" },
  { type: "Pension", label: "Pension / EPS", icon: "ShieldCheck", growth: 4, color: "#D96B43" },
  { type: "Annuity", label: "NPS Annuity", icon: "Repeat", growth: 0, color: "#6B7A99" },
  { type: "Dividend", label: "Dividend Income", icon: "Coins", growth: 6, color: "#8A9A5B" },
  { type: "PartTime", label: "Part-time / Consulting", icon: "Briefcase", growth: 5, color: "#B5651D" },
  { type: "Other", label: "Other Income", icon: "Wallet", growth: 0, color: "#7A6C5D" },
];

export const INCOME_COLORS = ["#2A6F7F", "#D99B26", "#D96B43", "#8A9A5B", "#6B7A99", "#B5651D", "#7A6C5D", "#2D6A4F"];

let _incomeId = 0;
export const makeIncomeSource = (type = "Rental", overrides = {}) => {
  const meta = INCOME_TYPES.find((t) => t.type === type) || INCOME_TYPES[0];
  return {
    id: `inc-${Date.now()}-${_incomeId++}`,
    type,
    label: meta.label,
    monthly: 0,
    startAge: 60,
    endAge: null,
    growth: meta.growth,
    ...overrides,
  };
};

export const buildDefaultInputs = (currency = "INR") => {
  return {
    currentAge: 35,
    retirementAge: 60,
    longevityAge: 90,
    currentCorpus: 0,
    monthlyExpenses: 0,
    annualExtra: 0,
    monthlyContribution: 0,
    contributionStepUp: 0,
    inflation: 5,
    inflationStartYear: 1,
    cityTier: "tier1",
    strategy: "bucket",
    numBuckets: 3,
    swpReturn: 8,
    swpRate: 4,
    withdrawalMode: "gap",
    buckets: THREE_BUCKETS.map((b) => ({ ...b })),
    incomeSources: [],
    currency,
  };
};
